import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import NutritionEditorActionsMenu from "../../shared/NutritionEditorActionsMenu";
import { buildNutritionPlanEditorActionItems } from "./nutritionPlanEditorActions";

function NutritionPlanEditorActionsMenu({
  onDuplicate = null,
  onDelete = null,
  onExportPdf = null,
  syncStatus = null,
  isExportingPdf = false,
}) {
  const { t } = useTranslation();
  const menuItems = useMemo(
    () =>
      buildNutritionPlanEditorActionItems({
        t,
        syncStatus,
        includeDuplicate: typeof onDuplicate === "function",
        includeDelete: typeof onDelete === "function",
        isExportingPdf,
      }),
    [isExportingPdf, onDelete, onDuplicate, syncStatus, t],
  );

  if (
    typeof onExportPdf !== "function" &&
    typeof onDuplicate !== "function" &&
    typeof onDelete !== "function"
  ) {
    return null;
  }

  return (
    <NutritionEditorActionsMenu
      items={menuItems}
      onAction={(actionKey) => {
        if (actionKey === "exportPdf") {
          onExportPdf?.();
          return;
        }

        if (actionKey === "duplicate") {
          onDuplicate?.();
          return;
        }

        if (actionKey === "delete") {
          onDelete?.();
        }
      }}
    />
  );
}

export default NutritionPlanEditorActionsMenu;
